module.exports = __webpack_public_path__ + "static/img/zj-rigth2.6fed77a4.png";